(function() {
  var root = document.querySelector('.alv');
  if (!root) return;

  var dataScript = document.getElementById('alv-variants-data');
  var variants = dataScript ? JSON.parse(dataScript.textContent) : [];

  var colorRadios = root.querySelectorAll('input[name="alv-color"]');
  var bundleRadios = root.querySelectorAll('input[name="alv-bundle"]');
  var variantInput = root.querySelector('#alv-variant-id');
  var heroImg = root.querySelector('.alv__hero-media img');
  var priceEl = root.querySelector('#alv-price');
  var compareEl = root.querySelector('#alv-price-compare');
  var topBadgeEl = root.querySelector('#alv-top-badge');
  var topBadgePctEl = root.querySelector('#alv-top-badge-pct');
  var topBadgeSavingsEl = root.querySelector('#alv-top-badge-savings');
  var installmentsAmountEl = root.querySelector('#alv-installments-amount');
  var ctaInstallmentsAmountEl = root.querySelector('#alv-cta-installments-amount');
  var ctaPriceCompareEl = root.querySelector('#alv-cta-price-compare');
  var ctaPriceSaleEl = root.querySelector('#alv-cta-price-sale');
  var thumbs = root.querySelectorAll('.alv__thumb');

  function getSelected(radios) {
    var checked = Array.prototype.find.call(radios, function(r) { return r.checked; });
    return checked ? checked.value : null;
  }

  function findVariant() {
    var color = getSelected(colorRadios);
    var bundle = bundleRadios.length ? getSelected(bundleRadios) : null;
    return variants.find(function(v) {
      return v.option1 === color && (bundle === null || v.option2 === bundle);
    });
  }

  function applyVariant(variant) {
    if (!variant) return;
    variantInput.value = variant.id;
    if (priceEl) priceEl.textContent = variant.price;
    if (compareEl) {
      compareEl.style.display = variant.has_compare ? '' : 'none';
      compareEl.textContent = variant.compare_at_price;
    }
    if (topBadgeEl) {
      topBadgeEl.style.display = variant.has_compare ? '' : 'none';
      if (topBadgePctEl) topBadgePctEl.textContent = variant.discount_pct + '% de desconto';
      if (topBadgeSavingsEl) topBadgeSavingsEl.textContent = variant.savings;
    }
    if (installmentsAmountEl && variant.installment) {
      installmentsAmountEl.textContent = variant.installment;
    }
    if (ctaInstallmentsAmountEl && variant.installment) {
      ctaInstallmentsAmountEl.textContent = variant.installment;
    }
    if (ctaPriceSaleEl) ctaPriceSaleEl.textContent = variant.price;
    if (ctaPriceCompareEl) {
      ctaPriceCompareEl.style.display = variant.has_compare ? '' : 'none';
      ctaPriceCompareEl.textContent = variant.compare_at_price;
    }
    if (heroImg && variant.image) {
      var allVideos = root.querySelectorAll('.alv__hero-video');
      allVideos.forEach(function(v) {
        v.hidden = true;
        var vid = v.querySelector('video');
        if (vid) { vid.pause(); }
      });
      heroImg.style.visibility = '';
      heroImg.src = variant.image;
    }
  }

  function onSelectionChange() {
    applyVariant(findVariant());
  }

  var swatchImgs = root.querySelectorAll('.alv__swatch img[data-color]');
  function updateSwatchImages() {
    var bundle = bundleRadios.length ? getSelected(bundleRadios) : null;
    swatchImgs.forEach(function(img) {
      var match = variants.find(function(v) {
        return v.option1 === img.dataset.color && (bundle === null || v.option2 === bundle);
      });
      if (match && match.image) { img.src = match.image; }
    });
  }

  colorRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      colorRadios.forEach(function(r) { r.closest('.alv__swatch').classList.remove('is-active'); });
      radio.closest('.alv__swatch').classList.add('is-active');
      onSelectionChange();
    });
  });

  bundleRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      bundleRadios.forEach(function(r) { r.closest('.alv__bundle-pill').classList.remove('is-active'); });
      radio.closest('.alv__bundle-pill').classList.add('is-active');
      updateSwatchImages();
      onSelectionChange();
    });
  });

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');

      var allVideos = root.querySelectorAll('.alv__hero-video');
      allVideos.forEach(function(v) {
        v.hidden = true;
        var vid = v.querySelector('video');
        if (vid) { vid.pause(); }
      });

      if (thumb.dataset.type === 'video') {
        var target = root.querySelector('.alv__hero-video[data-video-block-id="' + thumb.dataset.videoBlockId + '"]');
        if (target) {
          target.hidden = false;
          if (heroImg) { heroImg.style.visibility = 'hidden'; }
        }
      } else {
        if (heroImg) {
          heroImg.style.visibility = '';
          heroImg.src = thumb.dataset.image;
        }
      }
    });
  });

  var galleryPrevBtn = document.getElementById('alv-gallery-prev');
  var galleryNextBtn = document.getElementById('alv-gallery-next');
  function goToThumbOffset(offset) {
    if (!thumbs.length) return;
    var currentIndex = Array.prototype.findIndex.call(thumbs, function(t) { return t.classList.contains('is-active'); });
    if (currentIndex === -1) currentIndex = 0;
    var newIndex = (currentIndex + offset + thumbs.length) % thumbs.length;
    thumbs[newIndex].click();
  }
  if (galleryPrevBtn) galleryPrevBtn.addEventListener('click', function() { goToThumbOffset(-1); });
  if (galleryNextBtn) galleryNextBtn.addEventListener('click', function() { goToThumbOffset(1); });

  var heroMain = root.querySelector('.alv__hero-main');
  if (heroMain) {
    var swipeStartX = 0;
    var swipeStartY = 0;
    heroMain.addEventListener('touchstart', function(e) {
      swipeStartX = e.touches[0].clientX;
      swipeStartY = e.touches[0].clientY;
    }, { passive: true });
    heroMain.addEventListener('touchend', function(e) {
      var dx = swipeStartX - e.changedTouches[0].clientX;
      var dy = swipeStartY - e.changedTouches[0].clientY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        goToThumbOffset(dx > 0 ? 1 : -1);
      }
    }, { passive: true });
  }

  var reviewModal = document.getElementById('alv-review-modal');
  var writeReviewBtn = document.getElementById('alv-write-review-btn');
  var reviewModalClose = document.getElementById('alv-review-modal-close');
  var reviewModalBackdrop = document.getElementById('alv-review-modal-backdrop');

  function openReviewModal() { if (reviewModal) reviewModal.classList.add('is-open'); }
  function closeReviewModal() { if (reviewModal) reviewModal.classList.remove('is-open'); }

  if (writeReviewBtn) writeReviewBtn.addEventListener('click', openReviewModal);
  if (reviewModalClose) reviewModalClose.addEventListener('click', closeReviewModal);
  if (reviewModalBackdrop) reviewModalBackdrop.addEventListener('click', closeReviewModal);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeReviewModal();
  });

  var pagination = document.getElementById('alv-pagination');
  if (pagination) {
    var totalPages = parseInt(pagination.dataset.totalPages, 10) || 1;
    var reviewCards = root.querySelectorAll('.alv__review');
    var pageNumberBtns = pagination.querySelectorAll('.alv__pagination-number');
    var firstBtn = pagination.querySelector('[data-action="first"]');
    var prevBtn = pagination.querySelector('[data-action="prev"]');
    var nextBtn = pagination.querySelector('[data-action="next"]');
    var lastBtn = pagination.querySelector('[data-action="last"]');
    var currentPage = 1;

    function showPage(page) {
      page = Math.max(1, Math.min(totalPages, page));
      currentPage = page;
      reviewCards.forEach(function(card) {
        var cardPage = parseInt(card.dataset.reviewPage, 10);
        card.classList.toggle('alv__review--hidden', cardPage !== page);
      });
      pageNumberBtns.forEach(function(btn) {
        btn.classList.toggle('is-active', parseInt(btn.dataset.page, 10) === page);
      });
      if (firstBtn) firstBtn.disabled = page === 1;
      if (prevBtn) prevBtn.disabled = page === 1;
      if (nextBtn) nextBtn.disabled = page === totalPages;
      if (lastBtn) lastBtn.disabled = page === totalPages;
    }

    pageNumberBtns.forEach(function(btn) {
      btn.addEventListener('click', function() { showPage(parseInt(btn.dataset.page, 10)); });
    });
    if (firstBtn) firstBtn.addEventListener('click', function() { showPage(1); });
    if (prevBtn) prevBtn.addEventListener('click', function() { showPage(currentPage - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { showPage(currentPage + 1); });
    if (lastBtn) lastBtn.addEventListener('click', function() { showPage(totalPages); });

    showPage(1);
  }
})();

(function () {
  if (!('IntersectionObserver' in window)) return;
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  var root = document.querySelector('.alv');
  if (!root) return;


  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('alv-revealed');
      io.unobserve(entry.target);
    });
  }, {
    threshold: 0,
    rootMargin: '0px 0px -60px 0px'
  });

  root.querySelectorAll('[data-alv-reveal]').forEach(function (el) {
    io.observe(el);
  });
})();

(function () {
  if (!('IntersectionObserver' in window)) return;
  var videos = document.querySelectorAll('.alv__benefit-media video');
  if (!videos.length) return;
  var vio = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var vid = entry.target;
      if (entry.isIntersecting) {
        if (vid.preload !== 'auto') vid.preload = 'auto';
        var playPromise = vid.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      } else {
        vid.pause();
      }
    });
  }, { threshold: 0.25 });
  videos.forEach(function (v) { vio.observe(v); });
})();